import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import GridOptionsCart from "./GridOptions";
import GridColumnCart from "./GridColumn";
import VerticalAlignmentCart from "./VerticalAlignment";
import HorizontalAlignmentCart from "./HorizontalAlignment";
import NestingCart from "./Nesting";
import OrderCart from "./Order";
import OffsetCart from "./Offset";

const GridContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle="Grid" parent=" Ui Kits" title="Grid" />
      <Container fluid>
        <Row>
          <GridOptionsCart />
          <GridColumnCart />
          <VerticalAlignmentCart />
          <HorizontalAlignmentCart />
          <NestingCart />
          <OrderCart />
          <OffsetCart />
        </Row>
      </Container>
    </>
  );
};

export default GridContainer;
